import { useContext } from 'react'

import {
  IInfluencerIdentityIdContextProps,
  InfluencerIdentityIdContext,
  InfluencerIdentityIdProvider,
} from './Provider'

export {
  InfluencerIdentityIdProvider,
  InfluencerIdentityIdContext,
  type IInfluencerIdentityIdContextProps,
}

export const useInfluencerIdentityId = () => useContext(InfluencerIdentityIdContext)
